export const FETCH_CUSTOMER_REQUEST = 'FETCH_CUSTOMERS_REQUEST';
export const FETCH_CUSTOMER_RESPONSE = 'FETCH_CUSTOMERS_RESPONSE';
export const FETCH_CUSTOMER_FAILURE = 'FETCH_CUSTOMERS_FAILURE';

export interface Customer {
  NAME: string;
  address_1: string;
  address_2: '',
  town: string;
  county: string;
  pcode: string;
  country: '',
  contact_name: string;
  contact_tel: string;
  contact_mob: string;
  contact_email: string;
  sales_group: string;
  branch_address1: string;
  branch_address2: string;
  branch_email: string;
  branch_name: string;
  branch_pcode: string;
  branch_phone: string;
  branch_town: string;
  buying_group: '',
  rep_name: string;
  rep_Tel: '',
  rep_email: string;
  credit_limit: string;
  delivery_instructions: '',
  take_rolls: '',
  take_4m_rolls: '',
  take_pallets: '',
  max_delivery_wgt: '',
  delivery_address_code: string;
  payment_terms: string;
  lw_bank_name: '',
  lw_bank_sortcode: '',
  lw_bank_account: ''
}

export interface CustomerState {
  customer: Customer | null,
  isFetchingCustomer: boolean;
  fetchingCustomerFailed: boolean;
}

interface FetchCustomerRequestAction {
  type: typeof FETCH_CUSTOMER_REQUEST;
  payload: null;
}

interface FetchCustomerResponseAction {
  type: typeof FETCH_CUSTOMER_RESPONSE;
  payload: Customer;
}

interface FetchCustomerFailureAction {
  type: typeof FETCH_CUSTOMER_FAILURE;
  payload: null;
}

export type CustomerActionTypes =
  | FetchCustomerRequestAction
  | FetchCustomerResponseAction
  | FetchCustomerFailureAction;
